import { render, staticRenderFns } from "./TooltipDiscountCover.vue?vue&type=template&id=0104a596&scoped=true&"
import script from "./TooltipDiscountCover.vue?vue&type=script&lang=js&"
export * from "./TooltipDiscountCover.vue?vue&type=script&lang=js&"
import style0 from "./TooltipDiscountCover.vue?vue&type=style&index=0&id=0104a596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0104a596",
  null
  
)

export default component.exports